import { SCHEDULE } from "library/constants.mjs"
import { getGroupId, getScheduleId, normalizeGroupId } from "library/get-unique-id-from-tree.mjs"

/* converts a regime tree node id into a normalized context-less id only consisting of the node and any parent group node.
 * required for comparison between server accessor-scoped tailoredIds and tree-scoped client-side nodes.
 *
 * id shapes:
 * group node: -stage|regimeId!groupId
 * schedule: groupId-stage|regimeId!scheduleId
 */
export function normalizeNodeId({ id = "", type } = {}) {
    if (type !== SCHEDULE) return normalizeGroupId(id)
    return `${getGroupId(id)}!${getScheduleId(id)}`
}
